GP.views.PremiumViewerLayout = Backbone.Marionette.LayoutView.extend({
    initialize: function() {
        this.listenTo(GP.vent, 'PremiumViewerLayout:refresh_nanoscroller', this.refresh_nanoscroller, this);
        this.listenTo(GP.vent, 'PremiumViewerLayout:next_content', this.next_content, this);
        this.listenTo(GP.vent, 'PremiumViewerLayout:destroy_modal', this.destroy_modal, this);
        this.listenTo(GP.vent, 'PremiumViewerLayout:show_thumbnail_success', this.show_thumbnail_success, this);

        var current_url = (window.location.pathname + window.location.search).toLowerCase();
        this.is_profile = current_url.indexOf('profile') !== -1;

        if (this.model) {
            this.model.set('is_private', (this.model.get('tags').indexOf('PRIVATE') !== -1));

            // This is to show the placeholder image instead of video if user is in safemode.
            if (this.model.get('type') == 'VIDEO' && this.model.get('placeholder_thumb')) {
                this.model.set('type', 'IMAGE');
            }
        }

        this.show_prev = this.show_prev();
        this.show_next = this.show_next();
    },
    template: function(serialized_data) {
        var check = (serialized_data.content.duid == GP.sdata.my_user.duid || serialized_data.content.purchased);

        if (serialized_data.content.content_na || !check) {
            // Show the media not available template
            return template('premium-viewer-na', serialized_data);
        } else {
            return template('premium-viewer-layout', serialized_data);
        }
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};
        data = {
            content: this.model.toJSON()
        };

        // Format gender
        data.content.gender =(data.content.gender == 'WOMAN') ? 'F' : 'M';

        data.content.is_profile = this.is_profile;
        data.content.show_prev  = this.show_prev;
        data.content.show_next  = this.show_next;

        var id     = this.model.get('premium_content_id'),
            duid   = this.model.get('duid'),
            dl_url = '/members/premium/download?premium_content_id=' + id + '&duid=' + duid,
            cp_url = '/members/premium/change_price_modal?premium_content_id=' + id + '&duid=' + duid;

        data.content.download_url     = dl_url;
        data.content.change_price_url = cp_url;

        return data;
    },
    templateHelpers: {
        content_type_image: function() {
            return (this.content.type == 'IMAGE');
        },
        content_type_video: function() {
            return (this.content.type == 'VIDEO');
        },
        show_prev: function() {
            return this.content.show_prev;
        },
        show_next: function() {
            return this.content.show_next;
        },
        user_online: function() {
            return (this.content.online_status == 'ONLINE') ? '' : 'hide';
        },
        show_options: function() {
            return (this.content.duid == GP.sdata.my_user.duid);
        },
        show_user_data: function() {
            if (this.content && this.content.age && this.content.location) {
                return true;
            }
            return false;
        },
        show_ext: function() {
            return (this.content.type == 'VIDEO') ? 'mp4' : 'jpg';
        }
    },
    // regions: {
    //     countRegion: '.media-count-region',
    //     commentRegion: '.media-comment-region'
    // },
    ui: {
        alert_general_error: '.alert-general-error',
        nanoscroller: '#nano-viewer-wrap',
        nano_content: '#nano-viewer-ct',
        media_prev: '.media-prev',
        media_next: '.media-next',
        btn_premium_delete: '.btn-premium-delete',
        btn_update_video_thumb: '.btn-update-video-thumb',
        thumbnail_success: '.alert-success.thumbnail-success',
        // img_loader: '.img-loader'
    },
    events: {
        'keydown @ui.comment_input' : 'input_keydown',
        'click @ui.media_prev': 'prev_content',
        'click @ui.media_next': 'check_next',
        'click @ui.btn_premium_delete': 'delete_premium',
        'click @ui.btn_update_video_thumb': 'update_video_thumb',
    },
    onRender: function() {
        var that = this;

        if (!this.model.get('content_na')) {
            if (this.model.get('type') == 'VIDEO' && !this.model.get('placeholder_thumb')) {
                GP.vent.trigger('Modal:remove_class', 'modal-premium-picture');
                GP.vent.trigger('Modal:add_class', 'modal-premium-video');

                if (MoshPit.get_size() != 'mobile') {
                    GP.vent.trigger('Video:setup');
                }
            }

            if (this.model.get('type') == 'IMAGE') {
                GP.vent.trigger('Modal:remove_class', 'modal-premium-video');
                GP.vent.trigger('Modal:add_class', 'modal-premium-picture');
            }

            if (MoshPit.get_size() == 'desktop' || MoshPit.get_size() == 'desktop-wide') {
                this.init_nanoscroller();
            }
        }

        if (this.show_prev || this.show_next) {
            $(document).on('keydown.content_arrow', function(e) {
                that.keyboard_arrows(e);
            });
        }

        this.hide_loader();
    },
    modelEvents: {
        'change:general_error': 'general_error',
    },    
    input_keydown: function(e) {
        var key = e.which || e.keyCode;
        if (key && key == 13) {
            e.preventDefault();
            this.add_comment(e);
            return;
        }
    },
    general_error: function() {
        this.ui.alert_general_error.addClass('show').text(this.model.get('general_error'));
    },
    init_nanoscroller: function() {
        this.ui.nanoscroller.addClass('nanoscroller nano');
        this.ui.nano_content.addClass('nano-content');
        this.ui.nanoscroller.nanoScroller(GP.Util.configs.nanoScroller);
    },
    refresh_nanoscroller: function() {
        this.ui.nanoscroller.nanoScroller();
    },
    show_prev: function() {
        if (GP.PremiumViewer.gallery.is_gallery) {
            var current_id = this.model.get('premium_content_id');
            var premium_collection = GP.reqres.request('PremiumViewer:get_collection');

            if (premium_collection.length == 1) {
                return false;
            }

            return true;
        } else {
            return false;
        }
    },
    show_next: function() {
        if (GP.PremiumViewer.gallery.is_gallery) {
            var current_id = this.model.get('premium_content_id');
            var premium_collection = GP.reqres.request('PremiumViewer:get_collection');

            if (premium_collection.length == 1) {
                return false;
            }

            return true;
        } else {
            return false;
        }
    },    
    prev_content: function() {
        if (this.model.get('type') == 'VIDEO' && MoshPit.get_size() != 'mobile') {
            GP.vent.trigger('Video:close');
        }
        this.destroy_modal();
        GP.vent.trigger('PremiumViewer:modal_direction', this.model.get('premium_content_id'), 'prev');
    },
    check_next: function() {
       
        this.next_content();
    },
    next_content: function() {
        if (this.model.get('type') == 'VIDEO' && MoshPit.get_size() != 'mobile') {
            GP.vent.trigger('Video:close');
        }
        this.destroy_modal();
        GP.vent.trigger('PremiumViewer:modal_direction', this.model.get('premium_content_id'), 'next');
    },
    show_loader: function() {
        // this.ui.img_loader.addClass('shown');
    },
    hide_loader: function() {
        // this.ui.img_loader.removeClass('shown');
    },
    show_thumbnail_success: function() {
        var self = this;
        self.ui.thumbnail_success.show();
        setTimeout(function() {
            self.ui.thumbnail_success.fadeOut();
        }, 2000);
    },
    destroy_modal: function() {
        this.destroy();
        $(document).off('keydown.content_arrow');
    },
    keyboard_arrows: function(e) {
        var key = e.which || e.keyCode;

        if (key && key == 37 && this.show_prev) {
            e.preventDefault();
            this.prev_content();
            return;
        } else if (key && key == 39 && this.show_next) {
            e.preventDefault();
            this.check_next();
            return;
        }
    },
    delete_premium: function(e) {
        e.preventDefault();
        if (confirm(js_lang.content.confirm_del)) {
            GP.vent.trigger('Premium:delete_content', this.model);
            GP.vent.trigger('Modal:close');
        }
    },
    // get the current time index of the video and create new thumbnail for video at the current time index
    update_video_thumb: function(e) {
        e.preventDefault();
        GP.vent.trigger("PremiumViewer:update_video_thumb", this.model);
    }
});








